import { generate } from '../index';
const moment = require('moment');
export default generate({
  env:              'development',
  closeInitialData: {
    // printed:         true,
    reservationType: 'close',
    closeDate:       moment()
      .add(5, 'days')
      .format('YYYY/MM/DD'),
    watertapCode:             '1234567-2222',
    applicantNameKana:        'スイドウ　タロウ',
    applicantName:            '水道　太郎',
    agentRelationshipType:    '4',
    agentName:                '水道　管理',
    agentRelationshipDetail:  '管理会社',
    email:                    'abc-def@hijk.co.jp',
    emailDouble:              'abc-def@hijk.co.jp',
    contactTelType:           '3',
    contactTel:               '5555-66-7777',
    contactTelCompany:        '会社名',
    payoffMethod:             '2',
    nextPostalcode:           '470-1101',
    nextPrefecture:           '愛知県',
    nextCity:                 '豊明市',
    nextAddress:              '沓掛町',
    nextBuilding:             '建物名',
    nextRoomNo:               '部屋番号',
    nextAddressTelType:       '3',
    nextAddressTel:           '5555-66-7777',
    nextAddressTelCompany:    '転居先会社名',
    closeOpen:                1,
    nextOpenDate:             '2019/03/15',
    paymentMethod:            '3',
    directDebitConfirm:       1,
    hasShippingAddress:       '1',
    shippingPostalcode:       '470-1101',
    shippingPrefecture:       '愛知県',
    shippingCity:             '豊明市',
    shippingAddress:          '沓掛町',
    shippingBuilding:         '発送先建物',
    shippingRoomNo:           '発送先部屋番号',
    shippingTel:              '5555-66-7777',
    shippingCustomerNameKana: 'スイドウ　タロウ',
    shippingCustomerName:     '水道　太郎'
  },
  openInitialData: {
    // printed:         true,
    reservationType: 'open',
    openDate:        moment()
      .add(5, 'days')
      .format('YYYY/MM/DD'),
    applicantNameKana:        'スイドウ　タロウ',
    applicantName:            '水道　太郎',
    agentRelationshipType:    '2',
    agentName:                '家族　名前',
    agentRelationshipDetail:  '配偶者',
    email:                    'test@example.com',
    emailDouble:              'test@example.com',
    openAddressTelType:       '3',
    contactTelType:           '1',
    contactTel:               '1111-22-3333',
    openPostalcode:           '470-1101',
    openPrefecture:           '愛知県',
    openCity:                 '豊明市',
    openAddress:              '沓掛町',
    openAddressTel:           '2222-33-4444',
    paymentMethod:            '3',
    hasShippingAddress:       '1',
    prevWatertapCode:         '1111111-1111',
    directDebitConfirm:       1,
    openBuilding:             '入居先建物',
    openRoomNo:               '入居先部屋番号',
    openAddressTelCompany:    '入居先会社名',
    shippingPostalcode:       '470-1101',
    shippingPrefecture:       '愛知県',
    shippingCity:             '豊明市',
    shippingAddress:          '沓掛町',
    shippingBuilding:         '発送先建物',
    shippingRoomNo:           '発送先部屋番号',
    shippingTel:              '3333-44-5555',
    shippingCustomerNameKana: 'ハッソウサキシメイ',
    shippingCustomerName:     '発送先氏名'
  }
});
